<span *ngIf="send" (click)="sendMessage()">
	<app-messages><ng-content select="[send-button]"></ng-content></app-messages>
</span>
<span *ngIf="connect" (click)="connectUser('')">
		<ng-content select="[connect-button]"></ng-content>
</span>
<span *ngIf="sent">
	<ng-content select="[sent-button]"></ng-content>
</span>
